import { Icon, Spinner, colorValue } from '@hai/ui-react';
import React from 'react';

interface Busy {
  busy: boolean;
  disabled?: boolean;
  isActive: boolean;
  activeIcon: string;
  inactiveIcon: string;
}

const BusyIcon: React.FunctionComponent<Busy> = ({ busy, isActive, activeIcon, inactiveIcon, disabled }: Busy) => {
  return busy ? (
    <Spinner loopTime={1} {...{ style: { width: '18px', height: '18px', margin: '0px 3px 0px 3px' } }} />
  ) : (
    <Icon iconname={isActive ? activeIcon : inactiveIcon} color={colorValue('haiui-gray-04')} className={`mk-busy-icon${disabled && ' disabled'}` } />
  );
};

export default BusyIcon;
